import { jwtDecode } from 'jwt-decode';

export const isGuestToken = (token: string) => {
  const decodedToken = jwtDecode(token) as Record<string, unknown>;
  return 'username' in decodedToken;
};
